<template lang="pug">
#NavBar()
  b-navbar(variant="light-primary" toggleable="lg").justify-content-start.base-navbar
    b-navbar-toggle( target="navbar-toggle-collapse" @click="openMenu = !openMenu").mr-3
    router-link(to="/")
      img(v-if="mostrar" src="../../assets/logo_original_samtek.png" style="height:23px; margin:5px").ml-0.align-self-center
    div.spacer

    div(v-if="openMenu && screenSize > breakpoints.sm && screenSize <= breakpoints.lg")
      GenericSearchFilterBar(ref="searchBar").mt-1.ml-3

    b-collapse#navbar-toggle-collapse( is-nav )
      b-nav-item.item(
        v-for="route in routes.filter((r) => r.meta ? r.meta.menu : false)"
        :key="route.path"
        v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
        :to="route.path"
        exact
      )
        span(@click="clearFilters(route.name)") {{ route.name }}

      b-nav-item-dropdown( text="Ventas" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropVentas : false)"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.meta.dropLabel || route.name }}

      b-nav-item-dropdown( text="Pedidos" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropPedidos : false)"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.meta.dropLabel || route.name }}

      b-nav-item-dropdown( :text="exceptionsText" v-if="!isRetailUser" @show="fetchExceptionCounts" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropExcepciones : false )"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.name }} {{ getCountLabel(route.name) }}

      b-nav-item-dropdown( text="Inventario" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropInv : false )"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.name }}

      b-nav-item-dropdown( text="Clientes" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropPublic : false )"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.name }}

      b-nav-item-dropdown( text="Reportes" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropReport : false )"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.name }}

      b-nav-item-dropdown( text="Campaña" v-if="!isRetailUser" )
        b-dropdown-item(
          v-for="route in routes.filter((r) => r.meta ? r.meta.LinkDropCampaign : false )"
          v-if="checkUserRoles(route.meta ? route.meta.roles : [])"
          :to="route.path"
          :key="route.path"
          exact
        )
          span.drop-item(@click="clearFilters(route.name)") {{ route.meta.dropLabel || route.name }}

      GenericSearchFilterBar(v-if="screenSize >= breakpoints.lg" ref="searchBar").mt-1

    .d-block.w-100(v-if="screenSize <= breakpoints.sm")
      GenericSearchFilterBar(ref="searchBar").mt-1

    div(
      v-if="screenSize > breakpoints.sm && screenSize <= breakpoints.lg"
      :class="{ 'ml-3': !openMenu, 'd-none': openMenu }"
    )
      GenericSearchFilterBar(ref="searchBar").mt-1

    .d-flex.ml-auto.righthand-items
      Notifications.ml-4.mt-2
      b-nav-item-dropdown(right).mr-n2
        template(v-slot:button-content)
          span#UserName {{ fullName }}
        b-dropdown-item(disabled)
          span.text-dark.font-weight-bold {{ userFullName }}
        b-dropdown-item(@click="handleLogout" link-class="sesion-item")
          span  Cerrar Sesión
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { routes } from '../../router'
import GenericSearchFilterBar from '../OT/ListOT/GenericSearchFilterBar.vue'
import checkRoles from '../../utils/permissions'
import Notifications from './Notifications.vue'
import axios from '../../plugins/axios'
import { wsClient } from '../../utils/websocket'
import settings from '../../../settings'

export default {
  components: {
    Notifications,
    GenericSearchFilterBar,
  },
  data() {
    return {
      fullName: '',
      userFullName: '',
      mostrar: true,
      routes,
      breakpoints: {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
      },
      screenSize: window.innerWidth,
      openMenu: false,
      exceptionCounts: { ot: null, ov: null, ovg: null },
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.screenSize = window.innerWidth
    })
  },
  created() {
    this.getUser()
    this.fetchExceptionCounts()
    wsClient.connect(settings.webSocketsUrl)
    this.unsubscribeExceptions = wsClient.on('excepcion:updated', () => {
      this.fetchExceptionCounts()
    })
  },
  destroyed() {
    document.getElementById('app').style.marginLeft = '0'
    document.getElementById('app').style.transition = 'none'
  },
  methods: {
    ...mapActions('AuthenticationStore', ['logout']),
    handleResize() {
      this.screenSize = window.innerWidth
    },
    getUser() {
      const { user } = JSON.parse(localStorage.getItem('user'))
      const firstName = user.first_name || 'N'
      const lastName = user.last_name || 'N'
      this.userFullName = `${firstName} ${lastName}`
      this.fullName = firstName
    },
    clearFilters(routeName) {
      console.log('clear filters', routeName)
      if (routeName === 'Trabajo en curso') {
        this.$refs.searchBar.clearSearcher()
      }
    },
    handleLogout() {
      this.logout()
      this.$router.push({ name: 'Login' })
    },
    async fetchExceptionCounts() {
      try {
        const { key } = JSON.parse(localStorage.getItem('user'))
        const config = { headers: { Authorization: `Token ${key}` } }
        const response = await axios.get('api/excepcion/menu-counts/', config)
        this.exceptionCounts = response.data
      } catch (error) {
        console.error('Error fetching exception counts:', error)
      }
    },
    getCountLabel(routeName) {
      if (routeName === 'Excepciones OT') {
        return this.exceptionCounts.ot !== null
          ? `(${this.exceptionCounts.ot})`
          : ''
      }
      if (routeName === 'Excepciones OV') {
        return this.exceptionCounts.ov !== null
          ? `(${this.exceptionCounts.ov})`
          : ''
      }
      if (routeName === 'Excepciones OVG') {
        return this.exceptionCounts.ovg !== null
          ? `(${this.exceptionCounts.ovg})`
          : ''
      }
      return ''
    },
    // show() {
    //   if (this.mostrar) {
    //     if (!this.inMobile()) {
    //       document.getElementById('app').style.marginLeft = '250px';
    //     }
    //     document.getElementById('menu').style.marginLeft = '250px';
    //     document.getElementById('app').style.transition = '0.3s';
    //     this.mostrar = false;
    //   } else {
    //     if (!this.inMobile()) {
    //       document.getElementById('menu').style.marginLeft = '-50px';
    //     }
    //     document.getElementById('menu').style.marginLeft = '-250px';
    //     document.getElementById('app').style.marginLeft = '0';
    //     document.getElementById('app').style.transition = '0.3s';
    //     this.mostrar = true;
    //   }
    // },
    checkUserRoles(roles) {
      return checkRoles({ roles, user: this.user })
    },
    inMobile() {
      return (
        Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0
        ) < 700
      )
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),

    isRetailUser() {
      return this.user?.user?.groups?.some((g) => g.name === 'Retail')
    },
    exceptionsText() {
      const total =
        (this.exceptionCounts.ot || 0) +
        (this.exceptionCounts.ov || 0) +
        (this.exceptionCounts.ovg || 0)
      return total > 0 ? `Excepciones (${total})` : 'Excepciones'
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.unsubscribeExceptions) this.unsubscribeExceptions()
  },
}
</script>

<style lang="scss" scoped>
@import '../../style/global.scss';

#NavBar::v-deep {
  margin-bottom: 30px;
  .navbar-expand {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
  #UserName {
    color: #525252;
    font-weight: 700;
    font-size: 15px;
  }
  #menu {
    z-index: 99;
    background: #fff;
    height: 100%;
    width: 250px;
    position: fixed;
    top: 0;
    left: -250px;
    padding: 20px;
    transition: 0.3s;
  }
  .btn-hide-menu {
    position: absolute;
    z-index: 100;
    top: 10px;
    right: 16px;
  }
  .boton {
    position: relative;
    // background: transparent;
    // border-color: transparent;
    // &:hover {
    //   background: transparent;
    //   border-color: transparent;
    // }
    &:focus {
      outline: none;
    }
  }
  .contenido {
    font-size: 14px;
    height: 32px;
    margin: 90px 0px;
  }

  .nav-item {
    padding-left: 0;
    border-radius: 5px;
    margin: 0 15px 0 0;
    cursor: pointer;
    .nav-link {
      color: #525252;
      font-size: 15px;
      font-weight: 400;
      margin-left: 0;
      padding-left: 0;
      padding-right: 0;
    }
    &:hover {
      .nav-link {
        color: #1D4ED8;
        font-weight: 500;
      }
    }
    .nav-link.router-link-active,
    .nav-link.router-link-exact-active {
      color: #1D4ED8;
      font-weight: 600;
    }
    &.dropdown:hover > .dropdown-menu {
      display: block;
      margin-top: 0;
    }
  }
  @include media-breakpoint-up(lg) {
    .nav-item,
    .nav-item .nav-link {
      white-space: nowrap;
    }

    @media (max-width: 1600px) {
      .nav-item {
        margin-right: 10px;
      }
      .nav-item .nav-link {
        font-size: 14px;
      }
    }

    @media (max-width: 1400px) {
      .nav-item {
        margin-right: 6px;
      }
      .nav-item .nav-link {
        font-size: 13px;
      }
      .nav-link .b-icon,
      .nav-item .dropdown-toggle::after {
        transform: scale(0.85);
      }
    }

    @media (max-width: 1200px) {
      .nav-item {
        margin-right: 1px;
      }
      .nav-item .nav-link {
        font-size: 12px;
      }
    }
  }
  li {
    list-style-type: none;
  }
  .imagen {
    width: 21px;
    margin-right: 10px;
    margin-left: 17px;
  }
  .sesion-item {
    color: #FF3838;
    font-size: 15px;
    &:active {
      background-color: #e9ecef;
      font-weight: bold;
    }
  }
  .drop-item {
    color: #525252;
    font-size: 15px;
  }
  .dropdown-item:hover .drop-item {
    color: #1D4ED8;
  }
}

#NavBar .navbar.base-navbar,
#NavBar .navbar {
  background-color: #F5F6FA !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;
  min-height: 55px;
  height: 55px;
  padding-top: 0;
  padding-bottom: 0;
  align-items: center;
}

.navbar-collapse {
  max-width: calc(100vw - 400px);
  min-width: 0;

  @include media-breakpoint-up(lg) {
    flex-wrap: nowrap;
  }
}

#NavBar ::v-deep .with-icon {
  width: 250px;
  flex: 0 1 250px;
  min-width: 140px;
}

@media (max-width: 1600px) {
  #NavBar ::v-deep .with-icon {
    width: 200px;
    flex-basis: 200px;
  }
}

@media (max-width: 1400px) {
  #NavBar ::v-deep .with-icon {
    width: 170px;
    flex-basis: 170px;
  }
}

@media (max-width: 1200px) {
  #NavBar ::v-deep .with-icon {
    width: 140px;
    flex-basis: 140px;
  }
}

.base-navbar {
  background: #F5F6FA;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  min-height: 55px;
  padding-left: clamp(16px, 5vw, 100px);
  padding-right: clamp(16px, 5vw, 100px);
}

.righthand-items {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
}

.mt-08 {
  margin-top: 0.8rem !important;
}

.spacer {
  height: 48px;
}
</style>
